import defer from "lodash/defer"
import each from "lodash/each"
import map from "lodash/map"
import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import { useState } from "react"
import reactHtmlParser from "react-html-parser"
import { makeStyles } from "tss-react/mui"
import getAlertVersion from "utils-lib/alerts"
import { Button } from "../../../../../Base"
import MajorAlert from "../MajorAlert/MajorAlert"

const useStyles = makeStyles()((theme) => ({
  carouselDot: {
    width: 4,
    height: 4,
    borderRadius: 2,
    background: theme.palette.background.white,
  },
  carouselDotActive: {
    background: `${theme.palette.background.yellow} !important`,
    width: `.5rem`,
    height: `.5rem`,
    borderRadius: `.5rem`,
  },
  carouselSection: {
    [theme.breakpoints.down("lg")]: {
      justifyContent: `space-between`,
    },
  },
  moreDismissSection: {
    [theme.breakpoints.down("lg")]: {
      marginTop: `.5rem`,
    },
  },
}))

const ALERT_VERSION = getAlertVersion()
const LOCAL_STORAGE_KEY = `${ALERT_VERSION}-alreadyVisited`

const AlertsCarousel = ({
  alertsFinal,
  onAlertsChange,
  onAlertClose,
  megaNavSelection,
  sendDataToParent,
}) => {
  const [toggleAlertClose, setToggleAlertClose] = useState(false)
  const [currentAlert, setCurrentAlert] = useState(0)
  const [viewAll, setViewAll] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const [closeAll, setCloseAll] = useState(false)

  const { classes } = useStyles()

  function hideNotification(title) {
    const visitedAlerts = localStorage.getItem(LOCAL_STORAGE_KEY)

    let newVisitedAlerts = { [title]: true }
    if (visitedAlerts) {
      try {
        newVisitedAlerts = { ...newVisitedAlerts, ...JSON.parse(visitedAlerts) }
      } catch (e) {
        /* do nothing, use default newVisitedAlerts value */
      }
    }

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newVisitedAlerts))

    setToggleAlertClose(!toggleAlertClose)
  }

  if (isEmpty(alertsFinal)) {
    return null
  }

  const firstAlert = get(alertsFinal, `[${currentAlert}]`, {})

  const alertData = {
    logo: firstAlert.logo,
    title: firstAlert.title,
    linktext: firstAlert.linktext,
    href: firstAlert.href,
    subtext: firstAlert.subtext,
    iconClose: firstAlert.iconClose,
    backgroundColor: firstAlert.backgroundColor,
  }

  function moreDismissSection(data) {
    return (
      <div className={`wm-font-size-sm ${classes.moreDismissSection}`}>
        {!viewAll &&
          (get(data, `subtext.length`, 0) > 80 ||
            (data.linktext && data.href)) && (
            <Button
              overrideClass="wm-text-yellow p-0 mr-3"
              fontClass="maax-font-weight-regular"
              onClick={() => {
                setShowMore(!showMore)
              }}
            >
              <u>{showMore ? `Less` : `More`}</u>
            </Button>
          )}
        <Button
          overrideClass="wm-text-yellow p-0"
          fontClass="maax-font-weight-regular"
          onClick={() => {
            hideNotification(data.title)
            sendDataToParent(alertsFinal.length)
          }}
        >
          <u>Dismiss</u>
        </Button>
      </div>
    )
  }

  function carouselSection() {
    if (get(alertsFinal, `length`, 0) < 2) {
      return null
    }

    return (
      <div
        className={`AlertsCarousel__carousel-section d-flex align-items-center ${classes.carouselSection}`}
      >
        <div className="d-flex">
          {!viewAll &&
            map(alertsFinal, (item, index) => (
              <Button
                key={index}
                className={`pl-1 mx-1 ${
                  index === alertsFinal.length - 1 ? `pr-0` : `pr-1`
                }`}
                fontClass="maax-font-weight-bold"
                onClick={(e) => {
                  e.preventDefault()
                  setCurrentAlert(index)
                }}
                ariaLabel={`alert button ${index + 1}`}
                ariaPressed={currentAlert === index}
              >
                <span
                  className={`AlertsCarousel__dot ${classes.carouselDot} ${
                    index === currentAlert ? classes.carouselDotActive : ``
                  } `}
                />
              </Button>
            ))}
        </div>
        <div data-testid="AlertsCarousel-view-all-button">
          <Button
            ariaExpanded={viewAll}
            className="AlertsCarousel__view-all-button wm-text-yellow pl-0 ml-2"
            onClick={() => {
              setViewAll(!viewAll)
            }}
          >
            {reactHtmlParser(`View All (${get(alertsFinal, `length`, 0)})&nbsp;
          ${viewAll ? `&#9652;` : `&#9662;`}`)}
          </Button>
        </div>
      </div>
    )
  }

  if (closeAll) {
    return null
  }

  return (
    <div
      data-testid="AlertsCarousel"
      id="AlertsCarousel"
      className={`maax-font-weight-regular ${classes.root}`}
      style={{
        background: "#023625",
        display: megaNavSelection ? "none" : "block",
      }}
    >
      {viewAll ? (
        map(alertsFinal, (item, index) => {
          const alertData = {
            logo: item.logo,
            title: item.title,
            linktext: item.linktext,
            href: item.href,
            subtext: item.subtext,
            iconClose: item.iconClose,
            backgroundColor: item.backgroundColor,
          }
          return (
            <MajorAlert
              key={`title-${alertData.title}`}
              majorAlerts={alertData}
              onAlertsChange={onAlertsChange}
              onAlertClose={() => {
                onAlertClose()
                each(alertsFinal, (item) => {
                  hideNotification(item.title)
                })
                defer(() => {
                  setToggleAlertClose(!toggleAlertClose)
                })
              }}
              moreDismissSection={moreDismissSection(alertData)}
              carouselSection={index === 0 ? carouselSection() : null}
              viewAll={viewAll}
              showMore={showMore}
            />
          )
        })
      ) : (
        <MajorAlert
          key={`title-${alertData.title}`}
          majorAlerts={alertData}
          onAlertsChange={onAlertsChange}
          onAlertClose={() => {
            onAlertClose()
            each(alertsFinal, (item) => {
              hideNotification(item.title)
            })
            setCloseAll(true)
          }}
          moreDismissSection={moreDismissSection(alertData)}
          carouselSection={carouselSection()}
          viewAll={viewAll}
          showMore={showMore}
        />
      )}
      {viewAll && (
        <div className="d-md-none container ml-2">{carouselSection()}</div>
      )}
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// AlertsCarousel.propTypes = {
//   alertsFinal: PropTypes.object.isRequired,
//   onAlertsChange: PropTypes.func.isRequired,
//   onAlertClose: PropTypes.func.isRequired,
//   megaNavSelection: PropTypes.string.isRequired,
//   sendDataToParent: PropTypes.func.isRequired,
// }

export default AlertsCarousel
